export default "__VITE_ASSET__DJHTMFVT__"